<script setup>
import '@sass/_results.scss';
import { resultsRender } from '@js/components/resultsRender';

const props = defineProps({
	item: {
		type: Object,
		required: false,
		default: () => ({})
	},
	filters: {
		type: Object,
		required: false,
		default: () => ({})
	}
});

const flightIndex = computed(() => resultsRender.response.flights.findIndex(flight => flight === props.item));
const html = computed(() => {
	resultsRender.searchParams.filters = props.filters;
	return resultsRender.getRowHtml(props.item, flightIndex.value, { filters: props.filters, displayShareButton: false, displayFavBtn: false });
});
</script>

<template>
  <div
    ref="results-card"
    class="results-card"
    v-html="html"
  />
</template>


<style lang="scss">
.abResult:not(.abResult--expandedOtas) .abResult__otaAndBuyPreview + .abResult__otaAndBuyPreview {
	.abResult__viewAllAgencies {
		flex-direction: row;
		width: 100%;
		margin-left: 0;

		> * {
			flex: 1 0 1;
			width: auto;
			min-width: auto;
			max-width: inherit;
		}
	}

	.agentPreview,
	.otaLink {
		display: none;
	}
}
.abResult:hover {
	box-shadow: initial !important;
	border-color: transparent !important;
}
.abResult{
	margin-bottom: 0 !important;
}
</style>
